import { render, staticRenderFns } from "./CompanyRiskLookup.vue?vue&type=template&id=b3c2639a&scoped=true"
import script from "./CompanyRiskLookup.vue?vue&type=script&lang=js"
export * from "./CompanyRiskLookup.vue?vue&type=script&lang=js"
import style0 from "./CompanyRiskLookup.vue?vue&type=style&index=0&id=b3c2639a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c2639a",
  null
  
)

export default component.exports